import { connect } from "react-redux";

import Einheiten from "./Einheiten";

export default connect(state => ({
	units: state.settings.units,
	auth: state.user
}))(Einheiten);
